
export var screenSize = {
    data() {
        return {
            windowWidth: window.innerWidth ,
            outerWidth: window.innerWidth
        };
    },
    created() {
    },
    methods: {
        handleWindowResize(event) {
            this.windowWidth = event.currentTarget.innerWidth;
        },
    },
    beforeDestroy: function() {
        window.removeEventListener('resize', this.handleWindowResize);
        // window.removeEventListener('resize', this.handleWindowResizeForSideNav);
    },
    mounted() {
        window.addEventListener('resize', this.handleWindowResize);
        // window.addEventListener('resize', this.handleWindowResizeForSideNav);
    },
    computed: {
        isDesktop: function() {
            if (this.windowWidth >= 1284) {
                // 1284
                return true
            } else {
                return false
            }
        },
        isDesktopExpertView: function() {
            if (this.windowWidth >= 1100) {
                // 1284
                return true
            } else {
                return false
            }
        },
        screenOuterSize : function() {
            return this.windowWidth;
        },
    }
}
